module.exports = __webpack_public_path__ + "img/Microtechnique_CMi_18-1536x864.9fbb30b3.jpg";